var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 988,
    height: 770.584,
    viewBox: "0 0 988 770.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179913",
    "data-name": "Group 179913",
    transform: "translate(-378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    d: "M50,0H706a0,0,0,0,1,0,0V768a0,0,0,0,1,0,0H50A50,50,0,0,1,0,718V50A50,50,0,0,1,50,0Z",
    transform: "translate(660)",
    fill: "#192939"
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_login_re_4vu2",
    transform: "translate(350.636 100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97466",
    "data-name": "Path 97466",
    d: "M424.5,859.684H895.521V376.4c0-102.822-83.651-186.473-186.473-186.473H610.972C508.151,189.931,424.5,273.582,424.5,376.4Z",
    transform: "translate(-117.527 -189.931)",
    fill: "#2d4862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97467",
    "data-name": "Path 97467",
    d: "M424.5,859.683H797.446V376.4a185.03,185.03,0,0,0-35.611-109.618c-.857-1.168-1.711-2.32-2.592-3.46A186.425,186.425,0,0,0,719.555,224.8c-.851-.619-1.706-1.228-2.573-1.837a186.034,186.034,0,0,0-40.614-21.24c-.853-.323-1.721-.647-2.589-.958a185.853,185.853,0,0,0-40.144-9.467c-.849-.116-1.72-.207-2.592-.3a188.783,188.783,0,0,0-40.141,0c-.869.091-1.74.182-2.6.3a185.817,185.817,0,0,0-40.134,9.466c-.869.311-1.737.634-2.592.958a185.565,185.565,0,0,0-40.142,20.926c-.867.6-1.734,1.2-2.589,1.813a188.386,188.386,0,0,0-23.723,20.085A186.2,186.2,0,0,0,462.7,263.328c-.878,1.136-1.733,2.289-2.588,3.454A185.032,185.032,0,0,0,424.5,376.4Z",
    transform: "translate(-19.452 -189.93)",
    fill: "#385a7b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 20.648,
    cy: 20.648,
    r: 20.648,
    transform: "translate(414.727 412.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97468",
    "data-name": "Path 97468",
    d: "M576.509,521.519H592.33l7.527-61.024H576.506Z",
    transform: "translate(-230.949 133.76)",
    fill: "#e2805d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97469",
    "data-name": "Path 97469",
    d: "M589.206,504.28H558.695v19.211h49.723A19.211,19.211,0,0,0,589.206,504.28Z",
    transform: "translate(-216.525 146.478)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97470",
    "data-name": "Path 97470",
    d: "M637.508,521.519H653.33l7.527-61.024H637.506Z",
    transform: "translate(-370.668 133.76)",
    fill: "#e2805d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97471",
    "data-name": "Path 97471",
    d: "M650.206,504.28H619.695v19.211h49.723A19.211,19.211,0,0,0,650.206,504.28Z",
    transform: "translate(-356.244 146.478)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97472",
    "data-name": "Path 97472",
    d: "M782.309,566.568a13.863,13.863,0,0,0-5.821-20.445L722.707,397.891l-26.464,14.442L757.65,553.989a13.938,13.938,0,0,0,24.659,12.579Z",
    transform: "translate(-357.385 -129.525)",
    fill: "#e2805d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97473",
    "data-name": "Path 97473",
    d: "M819.482,590.189a13.863,13.863,0,0,0,3.733-20.927l16.661-156.8-30.117,1.376-6.924,154.237a13.938,13.938,0,0,0,16.647,22.118Z",
    transform: "translate(-544.56 -125.293)",
    fill: "#e2805d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 31.695,
    cy: 31.695,
    r: 31.695,
    transform: "translate(291.272 177.519)",
    fill: "#e2805d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97474",
    "data-name": "Path 97474",
    d: "M750.123,562.307h95.555l-.115-.744c-.172-1.112-17.03-111.547-4.6-147.676a15.245,15.245,0,0,0-7.832-18.82h0c-17.772-8.369-51.887-18.675-80.68,6.335a36.436,36.436,0,0,0-12.207,30.192Z",
    transform: "translate(-474.998 -133.073)",
    fill: "#a83626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97475",
    "data-name": "Path 97475",
    d: "M733.72,463.952l43.02-8.728-20.165-47.786a18.063,18.063,0,1,0-34.979,9.03Z",
    transform: "translate(-381.393 -130.688)",
    fill: "#a83626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97476",
    "data-name": "Path 97476",
    d: "M837.505,479.4l2.586-59.286c1.961-11.145-4.419-21.68-14.231-23.4s-19.4,6.014-21.368,17.24l-9.721,55.4Z",
    transform: "translate(-540.276 -129.935)",
    fill: "#a83626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97477",
    "data-name": "Path 97477",
    d: "M751,517.049c-15.375,58.557-17.053,133.008-12.9,214.218l20.647-2.581L796.163,573.83,816.81,731.267l23.228-1.29c6.94-85.209,13.7-158.36,2.581-206.475Z",
    transform: "translate(-472.693 -94.913)",
    fill: "#4d6796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97478",
    "data-name": "Path 97478",
    d: "M762.759,386.97c5.913,6.3,16.894,2.917,17.664-5.687a10.4,10.4,0,0,0-.013-2.008c-.4-3.812-2.6-7.272-2.072-11.3a5.922,5.922,0,0,1,1.084-2.773c4.712-6.31,15.773,2.822,20.22-2.89,2.727-3.5-.478-9.017,1.614-12.931,2.762-5.167,10.942-2.618,16.071-5.447,5.707-3.148,5.366-11.9,1.609-17.231-4.582-6.5-12.615-9.962-20.549-10.461s-15.812,1.645-23.218,4.531c-8.416,3.28-16.76,7.812-21.939,15.211-6.3,9-6.9,21.1-3.754,31.619C751.391,374.008,757.93,381.827,762.759,386.97Z",
    transform: "translate(-460.676 -153.261)",
    fill: "#682e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97479",
    "data-name": "Path 97479",
    d: "M267.033,710.266h952.746a1.536,1.536,0,1,0,0-3.073H267.033a1.536,1.536,0,1,0,0,3.073Z",
    transform: "translate(-238.133 -39.682)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97480",
    "data-name": "Path 97480",
    d: "M505.888,688.443H673.649a8.343,8.343,0,0,0,8.388-8.279V305.709a8.343,8.343,0,0,0-8.388-8.279H505.888a8.343,8.343,0,0,0-8.388,8.279V680.164a8.344,8.344,0,0,0,8.388,8.279Z",
    transform: "translate(1.753 -158.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162961",
    "data-name": "Rectangle 162961",
    width: 184.537,
    height: 2.581,
    transform: "translate(499.253 259.887)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162962",
    "data-name": "Rectangle 162962",
    width: 184.537,
    height: 2.581,
    transform: "translate(498.607 407.143)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162963",
    "data-name": "Rectangle 162963",
    width: 2.581,
    height: 392.303,
    transform: "translate(623.138 138.725)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162964",
    "data-name": "Rectangle 162964",
    width: 2.581,
    height: 392.303,
    transform: "translate(558.614 138.725)",
    fill: "#ccc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.57374c38e19f460cfe60f2609b5ea8e8.svg";
export { ForwardRef as ReactComponent };